import { useState } from "react";
import { ReactComponent as PenIcon } from "../../../../assets/svg/icons/penEdit.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/svg/icons/search.svg";
import "./styles.css";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { useTranslation } from "react-i18next";
import { getLocalizedApiName } from "../../../../utils/i18n/getLocalizedApiName";

type TableVisualizationRowProps = {
  microAreaManagement: IMicroAreaManagementContent;
  isHistory: boolean;
};

const formatDateWithoutTimezone = (dateString: string): string => {
  if(dateString && dateString.length > 0) {
    const [year, month, day] = dateString.split(' ')[0].split('-');
    return `${day}/${month}/${year.slice(-2)}`;
  }
  return "";
};

export default function TableVisualizationRow({
  microAreaManagement,
  isHistory
}: TableVisualizationRowProps) {
  const { t, i18n } = useTranslation();
  const {
    setOptionForm,
    setDefaultValue
  } = useEditOnboarding();

  const frequencyTranslationKeys: Record<string, string> = {
    WEEKLY: "weekly",
    BIWEEKLY: "biweekly",
    MONTHLY: "monthly",
  };

  function formatDefaultValuesPasteureManagement(data: IMicroAreaManagementContent) {
    return {
      id: data.id,
      microAreas: data.micro_area.map((microArea: any) => (
        {
          label: `${microArea.farm.initials}-${microArea.area.initials}-${microArea.initials}`,
          value: microArea.id,
          info: microArea
        }
      )),
      type: {
        label: getLocalizedApiName(data.type.name, i18n.language),
        value: data.type.id
      },
      monitor: {
        label: getLocalizedApiName(data.type.monitoring_types[0].name, i18n.language),
        value: data.type.monitoring_types[0].id
      },
      frequency: data.frequency,
      days_of_week: data.days_of_week,
      execution_per_day: data.execution_per_day,
      start_date: data.start_date,
      end_date: data.deactivated_at,
      max_rate: data.max_rate,
      requirement_in: data.requirement_in,
      requirement_out: data.requirement_out,
      farm: data.micro_area[0].farm,
      area: data.micro_area[0].area
    }
  }

  return (
    <tr>
      <td>{microAreaManagement.micro_area_management_group_initials}</td>
      <td>{microAreaManagement.micro_area[0].farm.name}</td>
      <td>{microAreaManagement.micro_area[0].area.name}</td>
      <td title={microAreaManagement.micro_area.map((ma: any) => ma.initials).join(", ")}>{microAreaManagement.micro_area.length == 1 ? microAreaManagement.micro_area[0].initials : t("tables.paddockCount", { count: microAreaManagement.micro_area.length })}</td>
      {microAreaManagement.type && <td>
        {getLocalizedApiName(microAreaManagement.type.name, i18n.language)}
        <br />
        {getLocalizedApiName(microAreaManagement.type.monitoring_types[0]?.name, i18n.language)}
      </td>}
      <td>
        {microAreaManagement.frequency && frequencyTranslationKeys[microAreaManagement.frequency]
          ? t(`formsV2.frequencies.${frequencyTranslationKeys[microAreaManagement.frequency]}`)
          : microAreaManagement.frequency || ""}
        <br />
        {microAreaManagement.days_of_week && microAreaManagement.days_of_week.length != 0
          ? `${microAreaManagement.days_of_week.length} ${t("formsV2.daysSuffix")}`
          : ""}
      </td>
      <td>{formatDateWithoutTimezone(microAreaManagement.start_date)}</td>
      {isHistory && (
        <td>{formatDateWithoutTimezone(microAreaManagement.deactivated_at)}</td>
      )}
      <td className="infoButton">
        {isHistory ?
          <SearchIcon
            onClick={() => {
              setOptionForm("pasture-management")
              setDefaultValue(formatDefaultValuesPasteureManagement(microAreaManagement))
            }}
            className="searchIcon"
          />
          :
          <PenIcon
            onClick={() => {
              setOptionForm("pasture-management")
              setDefaultValue(formatDefaultValuesPasteureManagement(microAreaManagement))
            }}
          />}
      </td>
    </tr>
  );
}
